<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'file-export']" />
        <span class="title">Export results</span> </Header
      ><br /><br /><br /><br />
      <v-btn
        :href="
          'https://trafficdistillery.com/tracking/resultsnew/' +
            this.$session.get('PROJID')
        "
        >Download</v-btn
      >
    </v-container>
  </v-app>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  data() {
    return {
      ncols: 6,
      i: 1
    };
  },
  components: {
    Header
  }
};
</script>
